import PropTypes from 'prop-types';
import { get } from 'lodash';
// components
import toastr from 'shared/helpers/toastr';

const errorToastr = ({ error, messagePrefix = '', messagePostFix = '', fallbackMessage = '', callback = null, showValidationErrors = true }) => {
  // Check if this is a cancellation error from the delete confirmation
  // Either by checking the error message or a custom property on the error
  if (error?.message?.includes('Delete operation cancelled by user') || 
      error?.isCancellation || 
      (error?.response?.data?.message?.includes('Delete operation cancelled by user'))) {
    // Silently ignore cancellation errors
    return null;
  }

  let message;
  let detail = get(error, 'response.data.Detail');
  let description = get(error, 'response.data.Description');
  let statusText = get(error, 'response.StatusText');
  if (detail) {
    if (typeof detail === 'string' && detail.indexOf('{') >= 0) {
      try {
        detail = JSON.parse(detail);
        if (detail && detail.message) {
          message = detail.message;
        }
      } catch (err) {
        if (callback) {
          callback(detail);
        }
        return toastr('error', `${messagePrefix} ${fallbackMessage} ${messagePostFix}`);
      }
    } else {
      message = detail;
    }
  } else if (description) {
    message = description;
  } else if (error?.response && error.response.statusText) {
    message = statusText;
  } else {
    message = fallbackMessage;
  }
  if (callback) {
    callback(message);
  }

  const validationErrors = error?.response?.data?.errors;

  if (validationErrors && showValidationErrors) {
    const errors = Object.values(validationErrors);
    errors.map(errorMessages => {
      errorMessages.forEach(msg => {
        message += `</br></br> ${msg}`;
      });
    });
  }

  return toastr('error', `${messagePrefix} ${message} ${messagePostFix}`);
};

errorToastr.propTypes = {
  error: PropTypes.object,
  messagePrefix: PropTypes.string,
  messagePostFix: PropTypes.string,
  fallbackMessage: PropTypes.string,
  callback: PropTypes.func || null
};

// Pass the errors object to the function
export const validationErrorToast = (errorTotal, errors = {}) => {
  if (!errors || Object.keys(errors).length === 0) {
    return toastr('error', `Please resolve ${errorTotal} issue${errorTotal > 1 ? 's' : ''}`);
  }

  // Build a detailed error message
  let message = `Please fix the following error${errorTotal > 1 ? 's' : ''}:`;

  Object.entries(errors).forEach(([fieldName, errorMessage]) => {
    // Format field name to be more readable (convert camelCase to Title Case)
    const readableFieldName = fieldName
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase())
      .trim();

    message += `</br></br><strong>${readableFieldName}:</strong> ${errorMessage}`;
  });

  return toastr('error', message);
};
export default errorToastr;
